export default __webpack_public_path__ + "static/zenith-4-9d25a90227c6fce8a4dba6b93ca30202.jpg";